module.exports = __webpack_public_path__ + "img/person-files.beb615ac.png";